export const Frequency = [
  { label: 'Diary', value: 'Daily'},
  { label: 'Monthly', value: 'Monthly'}
];

export const Days = [
  { label: 'Monday', value: 'Monday'},
  { label: 'Tuesday', value: 'Tuesday'},
  { label: 'Wednesday', value: 'Wednesday'},
  { label: 'Thursday', value: 'Thursday'},
  { label: 'Friday', value: 'Friday'},
  { label: 'Saturday', value: 'Saturday'},
  { label: 'Sunday', value: 'Sunday'}
];

export const Months = [
  { label: 'January' , value: 'January'},
  { label: 'February' , value: 'February'},
  { label: 'March' , value: 'March'},
  { label: 'April' , value: 'April'},
  { label: 'May' , value: 'May'},
  { label: 'June' , value: 'June'},
  { label: 'July' , value: 'July'},
  { label: 'August' , value: 'August'},
  { label: 'September' , value: 'September'},
  { label: 'October' , value: 'October'},
  { label: 'November' , value: 'November'},
  { label: 'December' , value: 'December'}
];

export const AllDays = () => {
  let limit = 1;
  let days = [];

  while (limit <= 31) {
    days.push({ key: `${limit}`, text: `${limit}`, value: `${limit}`});
    limit++;
  }
  return days;
};